// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:32
import { FullCrewResource_abstract } from './../abstract/SagaSchema/FullCrewResource_abstract';
export class FullCrewResource extends FullCrewResource_abstract {}
